<template>
  <v-card v-if="!isLoading" outlined>
    <v-toolbar class="elevation-0" height="45" color="gray">
      <v-toolbar-title>
        <h1 class="subtitle-1">{{ $t("labels.creditCard") }}</h1>
      </v-toolbar-title>
      <v-spacer> </v-spacer>
      <v-btn color="pink" small dark="dark" icon @click="add" v-if="!location.isCanceled">
        <v-icon small>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <div v-if="location.stripeID">
      <v-list two-line="two-line" subheader="subheader" v-if="cards.sources">
        <template v-for="(card, index) in cards.sources.data">
          <v-list-item :key="index" ripple="ripple">
            <v-list-item-action> </v-list-item-action>
            <v-list-item-content v-if="card.id === cards.default_source">
              <v-list-item-title
                >{{ card.type }} - {{ card.last4 }} - {{ card.funding
                }}<v-list-item-subtitle
                  >{{ card.exp_month }} / {{ card.exp_year
                  }}<v-chip small color="#D0E9FF">default</v-chip>
                </v-list-item-subtitle>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-content class="pointer" v-else>
              <v-list-item-title>
                <a @click="switchCard(card)"
                  >{{ card.type }} - {{ card.last4 }} - {{ card.funding }}</a
                >
              </v-list-item-title>
              <v-list-item-subtitle
                >{{ card.exp_month }} / {{ card.exp_year }}</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="index + 1 < cards.sources.data.length"> </v-divider>
        </template>
      </v-list>
    </div>
    <CreditCard :cardDialog="cardDialog" @getCard="getCard" @close="cardDialog = false">
    </CreditCard>
  </v-card>
</template>

<script>
import locationService from "../service.js";
import CreditCard from "../../Invoice/components/CreditCard";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      cards: [],
      cardDialog: false,
      isLoading: false
    };
  },
  components: {
    CreditCard
  },
  computed: {
    ...mapGetters("location", ["location"])
  },
  methods: {
    add() {
      this.cardDialog = true;
    },
    switchCard(card) {
      this.$swal({
        title: "Are you sure?",
        text: `You want to make card ending with ${card.last4} default card?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          var data = {
            stripeID: this.location.stripeID,
            id: card.id,
            storeID: this.location.storeID
          };
          return locationService
            .switchCard(data)
            .then(response => {
              if (response.data) {
                this.$swal("Deleted!", "Card has been deleted.", "success");
              }
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "success",
                  title: "Card switch successfully"
                });
              this.$Progress.finish();
              this.getCard();
            })
            .catch(error => {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "error",
                  title: err.data.message
                });
              this.$Progress.fail();
            });
        }
      });
    },
    getCard() {
      if (this.location.stripeID) {
        locationService
          .getCardByStore(this.location.storeID)
          .then(response => {
            this.cards = response.data;
          })
          .catch(error => {
            throw error;
          });
      }
    },
    deleteCard(card) {
      this.$swal({
        title: "Are you sure?",
        text: `You want to remove card ending with ${card.last4}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          var data = {
            stripeID: this.location.stripeID,
            id: card.id,
            storeID: this.location.storeID
          };
          return locationService
            .deleteCard(data)
            .then(response => {
              if (response.data) {
                this.$swal
                  .mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000
                  })
                  .fire({
                    type: "success",
                    title: "Card has been deleted"
                  });
                // this.$swal('Deleted!', 'Card has been deleted.', 'success')
              }
              this.$Progress.finish();
              this.getCard();
            })
            .catch(err => {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "error",
                  title: err.data.message
                });
              this.$Progress.fail();
            });
        }
      });
    }
  },
  watch: {
    location() {
      this.getCard();
    }
  },
  mounted() {
    this.getCard();
  }
};
</script>

<style scoped></style>
